export const environment = {
  production: false,
  tenant: 'xineus',
  apiBaseUrl: 'https://api.xineus.code-hive.de',
};
